import { useMemo } from 'react';

import { useLocale } from 'shared/presentation/contexts';

/**
 * Formata percentual com o separador decimal do país — "28,75", e não "28.75" ao lado de um
 * valor em reais formatado com vírgula.
 */
export default function usePercentageFormatter() {
  const { language } = useLocale();

  return useMemo(
    () => new Intl.NumberFormat(language, { maximumFractionDigits: 2 }),
    [language],
  );
}
